import { getIframeToken, isInIframe } from './iframe';
/**
 * Fetch wrapper that automatically adds Bearer token in iFrame context.
 * In normal (non-iFrame) context, uses credentials: 'include' for cookies.
 *
 * This is the central auth-aware fetch function that should be used for all
 * REST API calls. In iFrame context (embedded in WebUntis), cookies are blocked
 * by Safari ITP, so we use JWT Bearer tokens instead.
 */
export const authFetch = async (url, options = {}) => {
    const headers = new Headers(options.headers);
    if (isInIframe()) {
        const token = getIframeToken();
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
    }
    // Credentials: 'include' is harmless in iFrame (cookie just won't be sent)
    return fetch(url, {
        ...options,
        credentials: 'include',
        headers,
    });
};
